import { push } from "react-router-redux";
import { t } from "ttag";

import { Link } from "metabase/common/components/Link/Link";
import { ToolbarButton } from "metabase/common/components/ToolbarButton";
import { useDispatch } from "metabase/redux";
import * as Urls from "metabase/urls";
import type { Collection } from "metabase-types/api";

interface CollectionPermissionsProps {
  collection: Collection;
}

export const CollectionPermissions = ({
  collection,
}: CollectionPermissionsProps) => {
  const dispatch = useDispatch();
  const url = `${Urls.collection(collection)}/permissions`;

  return (
    // tabIndex={-1}: ToolbarButton's own `e.preventDefault()` means this
    // <Link> was never going to navigate on its own regardless of which
    // element wraps which (see the manual `dispatch(push(url))` below) — it
    // exists only to give the control a real `href` (hover status bar,
    // right-click "open in new tab"). The nested ToolbarButton is the only
    // element meant to be a Tab stop (WCAG 2.1.1, widget_tabbable_single).
    <Link to={url} tabIndex={-1}>
      <ToolbarButton
        icon="lock"
        aria-label={t`Edit permissions`}
        tooltipLabel={t`Edit permissions`}
        tooltipPosition="bottom"
        onClick={() => {
          // ToolbarButton has "e.preventDefault", so we have to navigate manually
          dispatch(push(url));
        }}
      />
    </Link>
  );
};
